import { axios } from './axios';
import { endpoints } from '../constants';

export default {
  async create(body: {
    subscriptionName: string;
    businessId: string;
    couponIds?: string[];
    token?: string;
  }) {
    const { onboardingBillingUrl } = endpoints();

    try {
      const { data } = await axios.post(`${onboardingBillingUrl}`, body);
      return data;
    } catch (error) {
      throw new Error('Failed to update subscription');
    }
  },
};
